<template>
  <div>
    <div class="content">
      <div class="article-top-bg">
        卡券新闻
      </div>
    	<div class="container help-center" v-loading="loading">
        <div class="articel-main-left">
          <div class="subnav">
            <ul class="subnav-tabs">
              <span v-for="(item,index) in cardList" :key="index">
                <li :class="{active:item.category_id === cate_id}">
                  <a href="javascript:void(0);" @click="tabCate(item)">{{item.name}}</a>
                </li>
                <li class="divider" v-if="index+1 != cardList.length"></li>
              </span>
            </ul>
          </div>
          <div class="help-main " style="margin-left: 0;" >
          	<h2>卡券新闻</h2>
            <div style="margin-left:-20px;" v-if="articleList.length > 0">
              <div v-for="(item,index) in articleList" class="articel-list-item" :key="index" @click="openDetail(item)">
                <img :src="item.image?item.image.file_path:''" class="ql-article-img" />
                <div class="articel-list-item-right">
                  <div class="h3" >{{item.article_title}}</div>
                  <div class="info">{{item.abstract}}</div>
                  <div class="articel-list-item-right-bottom">
                    <div>
                      {{item.view_time}}
                    </div>
                    <div>
                      <i class="clock-icon icon-guankan  iconfont"></i>
                      {{item.actual_views}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <el-empty description="暂无内容" />
            </div>
            <div class="text-right">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="articleCurrent_page"
                :page-size="articlePer_page"
                layout="prev, pager, next, jumper,total"
                :page-count='articleLast_page'
                :total="articleTotal">
              </el-pagination>
            </div>
          </div>
        </div>
        <div class="article-main-right">
          <h2 class="text-red">热门新闻</h2>
          <div>
            <div v-for="(item,index) in hotArticle" class="article-hot-item" :key="index" @click="openDetail(item)">
              <img :src="item.image?item.image.file_path:''" class="ql-article-img" />
              <div class="article-hot-item-right">
                <div class="h4">{{item.article_title}}</div>
                <div class="articel-list-item-right-bottom dqwfwttt" >
                  <div>
                    {{item.view_time}}
                  </div>
                  <div>
                    {{item.actual_views}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    	</div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
				loading:false,
				hotLoading:false,
				cardList:[
				],
				cate_id:"",
				articleList:[],
				articleCurrent_page:1,
				articlePer_page:15,
        articleLast_page:1,
				articleTotal:15,
				hotArticle:[]
      }
    },
    async created(){
      await this.getCategoryList()
      this.news_api()
      this.articleHotpc()
    },
    methods:{
      			handleCurrentChange(e){
      				this.articleCurrent_page = e
      				this.news_api()
      			},
      openDetail(item){
        this.$router.push({
          path:"/articleDetail",
          query:{article_id:item.article_id}
        })
      },
      tabCate(item){
        this.cate_id = item.category_id
        this.articleCurrent_page = 1
        this.news_api()
      },
      news_api(){
        this.loading = true
        this.$api.news_api({
          cate:this.cate_id,
          page:this.articleCurrent_page
        })
        .then(result => {
          this.articleCurrent_page = result.data.current_page
          this.articlePer_page = result.data.per_page
          this.articleLast_page = result.data.last_page
          this.articleTotal = result.data.total
          this.articleList = result.data.data
          this.loading = false
        })
      },
      articleHotpc(){
        this.hotLoading = true
        this.$api.articleHotpc()
        .then(result => {
          this.hotArticle = result.data.data
          this.hotLoading = false
        })
      },
      getCategoryList(){
        return new Promise((resolve,reject) => {
          this.$api.categorypc()
          .then(res => {
            let list = res.data
            this.cardList = list
            if(this.cardList.length > 0){
              this.cate_id = this.cardList[0].category_id
            }

            resolve()
          })
        })
      },
    }
  }
</script>

<style scoped>
@import './css/article.css';
</style>



// WEBPACK FOOTER //
// src/components/article/index.vue